import { useEffect, useState } from 'react'
import { Link, useHistory, useLocation } from 'react-router-dom'
import { Table, Select, Space, Row, Col, Flex } from '@/UI'
import { api } from '../../tools/request'
import jMoment from 'moment-jalaali'
import qs from 'qs'
import { formatPrice , renderCurrency, renderCurrencyColumn} from './utils'

const SERVICE_TYPES = {
  '': 'همه سرویس ها',
  ERSAL: 'فراارسال',
  PARDAZESH: 'پردازش سفارش',
  VOROUD: 'پردازش ورود کالا',
  ANBARESH: 'انبارش'
}

const SERVICE_TYPES_OPTIONS = Object.entries(SERVICE_TYPES).map(
  ([value, label]) => ({
    value,
    label
  })
)

const MONTHS =
  'فروردین_اردیبهشت_خرداد_تیر_مرداد_شهریور_مهر_آبان_آذر_دی_بهمن_اسفند'.split(
    '_'
  )

const MONTHS_OPTIONS = [
  ...Object.entries(MONTHS).map(([value, label]) => ({
    value: +value + 1,
    label
  }))
]



export default function Wallet() {
  const { search } = useLocation()
  const history = useHistory()
  const params = qs.parse(search ? search.slice(1) : '')

  const [data, setData] = useState({ serviceAccounts: [], totalAmount: 0 })
  const [loading, setLoading] = useState(false)
  const [month, setMonth] = useState(
    () =>
      +params.month ||
      +new Intl.DateTimeFormat('fa-IR-u-nu-latn', { month: 'numeric' }).format(
        new Date()
      )
  )
  const [year, setYear] = useState(() => +params.year || jMoment().jYear())
  const [serveiceCode, setServeiceCode] = useState(
    () => params.serveiceCode || ''
  )
  const [dateFrom, setDateFrom] = useState()
  const [dateTo, setDateTo] = useState()

  useEffect(() => {
    history.push(`?${qs.stringify({ year, month, serveiceCode })}`)
  }, [year, month, serveiceCode])

  const columns = [
    { key: 'serviceName', title: 'نام سرویس' },
    {
      key: 'parentType',
      title: 'نوع سرویس',
      render: (f: keyof typeof SERVICE_TYPES) => SERVICE_TYPES[f]
    },
    {
      key: 'totalIncome',
      title: renderCurrencyColumn('مبلغ خالص'),
      render: renderCurrency
    },
    {
      key: 'totalTax',
      title: renderCurrencyColumn('مالیات'),
      render: renderCurrency
    },
    {
      key: 'totalDiscount',
      title: renderCurrencyColumn('تخفیف'),
      render: renderCurrency
    },
    {
      key: 'totalAmount',
      title: renderCurrencyColumn('مبلغ نهایی'),
      render: renderCurrency
    },
    {
      key: 'action',
      render: (_, r) =>
        !(year <= 1403  && month <= 3) && (
          <Link to={`/wallet/${r.serviceCode}/${dateFrom}/${dateTo}`}>
            جزییات
          </Link>
        )
    }
  ]

  function getData() {
    const from = jMoment(`${year}-${month || 1}-1`, 'jYYYY-jM-jD')
      .locale('en')
      .format('YYYY-MM-DD')

    const to = jMoment(
      `${year}-${month || 12}-${month && month > 6 ? 30 : 31}`,
      'jYYYY-jM-jD'
    )
      .locale('en')
      .format('YYYY-MM-DD')
    setDateFrom(from)
    setDateTo(to)
    setLoading(true)
    api('/account-service/find-service-account-balance', {
      method: 'POST',
      data: {
        dateFrom: from,
        dateTo: to,
        serviceCodes: serveiceCode ? [serveiceCode] : null
      }
    })
      .then(({ data }) => setData(data))
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    getData()
  }, [serveiceCode, year, month])

  return (
    <div>
      <div>
        <Space style={{ marginBottom: '1rem' }}>
          <Select
            style={{ width: 220 }}
            size='large'
            placeholder='نوع سرویس'
            value={serveiceCode}
            onSelect={setServeiceCode}
          >
            {SERVICE_TYPES_OPTIONS.map(({ value, label }) => (
              <Select.Option style={{ padding: '.8rem' }} value={value}>
                {label}
              </Select.Option>
            ))}
          </Select>
          <Select
            style={{ width: 220 }}
            size='large'
            placeholder='ماه'
            value={month}
            onSelect={setMonth}
          >
            {MONTHS_OPTIONS.map(({ value, label }) => (
              <Select.Option style={{ padding: '.8rem' }} value={value}>
                {label}
              </Select.Option>
            ))}
          </Select>
          <Select
            style={{ width: 220 }}
            size='large'
            placeholder='سال'
            value={year}
            onSelect={setYear}
          >
            {Array.from({ length: 4 }, (_, i) => jMoment().jYear() - i).map((el) => (
              <Select.Option style={{ padding: '.8rem' }} value={el}>
                {el}
              </Select.Option>
            ))}
          </Select>
        </Space>
      </div>
      <Table
        data={data.serviceAccounts}
        columns={columns}
        loading={loading}
        pagination={false}
      />
      <Flex justify='end'>
        <Row
          gutter={10}
          style={{
            width: '625px',
            border: '1px solid #202D73',
            borderRadius: '4px',
            backgroundColor: '#fff',
            padding: '14px 38px',
            marginTop: '1.5rem',
            marginLeft: '0px'
          }}
        >
          <Col span={12} style={{ fontWeight: 600 }}>
            مجموع استفاده در {MONTHS[month - 1]} {year}
          </Col>
          <Col
            span={9}
            style={{ fontWeight: 600, fontSize: '1rem', color: '#202D73' }}
          >
            {formatPrice(data.totalAmount)}
          </Col>
          <Col span={3}>ریال</Col>
        </Row>
      </Flex>
    </div>
  )
}
